// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-help-menu-docs',
    templateUrl: './help-menu.docs.generated.html',
})
export class UIHelpMenuDocs { }
